
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API;


const SociosList = () => {
  const [socios, setSocios] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [grupoFamiliar, setGrupoFamiliar] = useState(null);
  const [loadingModal, setLoadingModal] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const [sociosPorPagina, setSociosPorPagina] = useState(25);
  const navigate = useNavigate();

  // Carga la lista de socios
  const fetchMembers = async () => {
    try {
      const response = await axios.get(`${API}/api/members`);
      setSocios(response.data || []);
    } catch (error) {
      console.error("Error al obtener miembros:", error);
      setSocios([]);
    }
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  const handleVerGrupoFamiliar = async (memberId) => {
    if (!memberId) return;
    setLoadingModal(true);
    setShowModal(true);
    try {
      const res = await axios.get(`${API}/api/members/family-group/${memberId}`);
      console.log(res.data)
      setGrupoFamiliar(res.data);
    } catch (e) {
      console.error("Error al obtener grupo familiar:", e);
      setGrupoFamiliar(null);
    }
    setLoadingModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
    setGrupoFamiliar(null);
  };

  // NUEVO: Cambia el estado del socio (activar/desactivar)
  const handleToggleStatus = async (socio) => {
    const id = socio.id || socio._id;
    Swal.fire({
      title: `¿Seguro que deseas cambiar el estado de "${socio.name}"?`,
      text: "Esto desactivará o reactivará el acceso de este socio.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar estado",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.put(`${API}/api/members/${id}/toggle-status`);
          if (res.data && res.data.member) {
            Swal.fire({
              icon: 'success',
              title: `Socio actualizado`,
              text: `Nuevo estado: ${res.data.member.membershipStatus}`,
              showConfirmButton: false,
              timer: 1800
            });
            fetchMembers();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: "No se pudo cambiar el estado.",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Error de red',
            text: 'No se pudo conectar al servidor.',
          });
        }
      }
    });
  };

  const renderDatosSocio = (socio) => (
    <div>
      <ul>
        <li><b>Nombre:</b> {socio?.name || 'N/A'}</li>
        <li><b>DNI:</b> {socio?.documento || 'N/A'}</li>
        <li><b>Email:</b> {socio?.email || 'N/A'}</li>
      </ul>
    </div>
  );

  const indexUltimo = paginaActual * sociosPorPagina;
  const indexPrimero = indexUltimo - sociosPorPagina;
  const sociosPagina = socios.slice(indexPrimero, indexUltimo);
  const totalPaginas = Math.ceil(socios.length / sociosPorPagina);

  const cambiarPagina = (pagina) => {
    if (pagina >= 1 && pagina <= totalPaginas) {
      setPaginaActual(pagina);
    }
  };

  const cambiarCantidadPorPagina = (e) => {
    setSociosPorPagina(parseInt(e.target.value));
    setPaginaActual(1); // reiniciar a la primera página al cambiar el tamaño
  };

  return (
    <div className="container-fluid mt-4 bg-white p-4 mb-5">
      <h2>Lista de Socios</h2>
      {/* Selector de cantidad por página */}
      <div className="mb-3 d-flex justify-content-end align-items-center gap-2">
        <label htmlFor="cantidadRegistros" className="form-label mb-0">Mostrar:</label>
        <select
          id="cantidadRegistros"
          className="form-select w-auto"
          value={sociosPorPagina}
          onChange={cambiarCantidadPorPagina}
        >
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={200}>200</option>
        </select>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Email</th>
              <th>Celular</th>
              <th>Edad</th>
              <th>Documento</th>
              <th>Estado</th>
              <th>Actividad</th>
              <th>Precio</th>
              <th>Años Socio</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sociosPagina.map((member) => {
              const id = member.id || member._id;
              return (
                <tr key={id}>
                  <td>{member.name}</td>
                  <td>{member.email}</td>
                  <td>{member.celular}</td>
                  <td>{member.edad}</td>
                  <td>{member.documento}</td>
                  <td>{member.status}</td>
                  <td>{member.actividad}</td>
                  <td>${member.precio}</td>
                  <td>{member.añosSocio}</td>
                  <td>
                    <div style={{ display: "flex", gap: "0.5rem" }}>
                      <button className="btn btn-sm btn-info" onClick={() => handleVerGrupoFamiliar(id)}>Ver</button>
                      <button className="btn btn-sm btn-primary" onClick={() => navigate(`/datos-socio/${id}`)}>Editar</button>
                      <button className="btn btn-sm btn-warning" onClick={() => handleToggleStatus(member)}>
                        {member.membershipStatus === "activo" ? "Activar" : "Desactivar"}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      <div className="d-flex justify-content-between align-items-center">
        <button className="btn btn-secondary" onClick={() => cambiarPagina(paginaActual - 1)} disabled={paginaActual === 1}>
          Anterior
        </button>
        <span>Página {paginaActual} de {totalPaginas}</span>
        <button className="btn btn-secondary" onClick={() => cambiarPagina(paginaActual + 1)} disabled={paginaActual === totalPaginas}>
          Siguiente
        </button>
      </div>

      {/* Modal */}
      <Modal isOpen={showModal} toggle={closeModal}>
        <ModalHeader toggle={closeModal}>
          {!loadingModal && Array.isArray(grupoFamiliar?.grupo) && grupoFamiliar?.grupo?.length > 1
            ? "Grupo Familiar"
            : "Datos del Socio"}
        </ModalHeader>
        <ModalBody>
          {loadingModal && <p>Cargando datos...</p>}
          {!loadingModal && grupoFamiliar && Array.isArray(grupoFamiliar?.grupo) ? (
            grupoFamiliar.grupo.length > 1 ? (
              <>
                <p><b>Responsable:</b> {grupoFamiliar.responsable?.name}</p>
                <ul>
                  {grupoFamiliar.grupo.map((m) => (
                    <li key={m.id || m._id}>
                      <b>{m.name}</b> - DNI: {m.documento} - Email: {m.email}
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              renderDatosSocio(grupoFamiliar?.grupo?.[0])
            )
          ) : (
            !loadingModal && <p>No se pudo obtener los datos.</p>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default SociosList;
